module.exports = __webpack_public_path__ + "img/scanImage.130fa3b5.png";